import { Modal, Select } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { enterTop } from "./Services/Sales/Checkout/styles";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  margin-top: 32px;
`;

export const FormContainer = styled.div`
  form {
    display: flex;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  font-size: 14px;
  font-weight: normal;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 21px;
  padding-left: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.16);
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const FieldsContainer = styled.div`
  margin-top: 16px;
`;

export const Horizontal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  & > div {
    display: flex;
    flex: 1 0 100px;
    margin-left: 16px;
    @media (max-width: 768px) {
      margin-left: 0px;
      flex: 1 1 auto;
      width: 100%;
    }
  }

  & > div:first-child {
    margin-left: 0px;
  }
`;

export const FilterActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  flex-wrap: wrap;

  & > div:first-child {
    margin-left: 0px;
  }

  @media (max-width: 500px) {
    width: 100%;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 16px;
    @media (max-width: 500px) {
      margin-left: 0px;
    }
  }
`;

export const SubmitContainer = styled.div`
  width: 100%;
  max-width: 150px;

  @media (max-width: 500px) {
    margin-left: 0px;
    max-width: none;
    width: 100%;
  }
`;

export const TableTitleContainer = styled.div`
  padding: 16px 0px 16px 24px;
`;

export const TableTitle = styled.p``;

export const LinkButton = styled(Link)`
  text-decoration: none;
`;

export const GoBackContainer = styled.div``;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;

  div {
    margin-left: 4px;
  }
  @media (max-width: 500px) {
    flex-direction: column;
    div {
      margin-left: 0px;
    }
  }
`;

export const BadgeContainer = styled.div`
  cursor: pointer;
  @media (max-width: 500px) {
    margin-top: 16px;
  }
`;

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 32px;

  div {
    margin-left: 16px;
  }

  div:first-child {
    margin-left: 0px;
  }
  @media (max-width: 500px) {
    flex-direction: column;
    div {
      margin-left: 0px;
    }
  }
`;

export const FantasyNameContractBadgeContainer = styled.div`
  background-color: #e2e2f733;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px;
  padding-left: 8px;
  width: fit-content;
  border-radius: 8px;

  & > span {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #314158;
    text-transform: capitalize;
  }
`;

export const CredentialsCardContainer = styled.div`
  width: 100%;
  height: 139px;
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 24px;
  padding-left: 16px;
  border-width: 1px;
  border-radius: 10px;
  background-color: rgba(248, 250, 251, 1);
  border: 1px soft rgba(226, 232, 240, 1);
  animation: ${enterTop} 1s;
`;
export const CredentialsCardTitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  padding-top: 12px;
  white-space: nowrap;
`;

export const CredentialsCardContent = styled.div`
  display: flex;
  width: 400px;
  height: 91px;
  flex-direction: column;
  border-left: 3px solid rgb(202, 213, 226);
  align-items: start;
  padding-left: 15px;
  gap: 0px;
`;
export const CredentialsCardSubTitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(98, 116, 142, 1);
  margin-top: -10px;
`;
export const CredentialsCardButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 585px) {
    display: block;
    padding-top: 10px;
  }
`;
export const CredentialsCardButtonTransfer = styled.button`
  width: 100px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid rgba(202, 213, 226, 1);
  background-color: rgba(255, 255, 255, 1);
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: rgba(69, 85, 108, 1);
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05); /* dá um leve zoom */
  }
`;
export const CredentialsCardButtonAssociate = styled.button`
  width: 100px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background-color: rgba(6, 142, 195, 1);
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05); /* dá um leve zoom */
  }
`;
export const AssocieteAndTransferModal = styled(Modal)`
  margin-top: 100px;

  .ant-modal-content {
    border-radius: 10px;
    height: auto;
  }
  .ant-modal-footer {
    border-top: none;
  }
`;

export const TransferCauntion = styled.p`
  margin-top: 5px;
  display: flex;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  color: rgba(104, 104, 110, 1);
`;

export const AssociateModalTitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 17px;
  padding-left: 0px;

  align-items: center;
`;

export const AssocieteModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AssociateModalSubTitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(49, 65, 88, 1);
`;
export const SelectCustom = styled(Select)`
  .ant-select-selector {
    width: 610px !important;
    min-height: 48px !important;
    border-radius: 10px !important;
    border: 1.5px solid rgba(223, 223, 224, 0.6) !important;
    box-shadow: 0px 1px 2px rgba(25, 25, 28, 0.04) !important;
    display: flex;
    align-items: center;
  }
  .ant-select-selection-placeholder {
    color: rgba(104, 104, 110, 1); /* Defina a cor desejada aqui */
  }

  .ant-select-selection-item {
    display: flex;
    align-items: center;
    color: rgba(104, 104, 110, 1);
  }

  .ant-select-selection-search-input {
    height: 100% !important;
  }
`;

export const ButtonAssociateModal = styled.button`
  width: 173px;
  height: 38px;
  margin-right: 10px;
  border-radius: 8px;
  border: none;
  background-color: rgba(6, 142, 195, 1);
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05); /* dá um leve zoom */
  }
  &:disabled {
    transition: none;
    transform: none;
    cursor: not-allowed;
    background-color: rgba(223, 223, 224, 1);
  }
`;

export const ButtonCancelModal = styled.button`
  width: 70px;
  margin-right: 10px;
  height: 38px;
  border: none;
  background-color: transparent;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: rgba(0, 34, 68, 1);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05); /* dá um leve zoom */
  }
`;
